import { push } from "react-router-redux";
import { stopSubmit } from "redux-form";
import { setPagination } from "./admin.actions";
import { setLoading } from "./common.actions";

import api from "../services/api";

export const SEARCH_COMPANIES_START = "SEARCH_COMPANIES_START";
export const SEARCH_COMPANIES_SUCCESS = "SEARCH_COMPANIES_SUCCESS";
export const SEARCH_COMPANIES_ERROR = "SEARCH_COMPANIES_ERROR";

export const UPDATE_COMPANY_START = "UPDATE_COMPANY_START";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_ERROR = "UPDATE_COMPANY_ERROR";

export const CREATE_COMPANY_START = "CREATE_COMPANY_START";
export const CREATE_COMPANY_SUCCESS = "CREATE_COMPANY_SUCCESS";
export const CREATE_COMPANY_ERROR = "CREATE_COMPANY_ERROR";

export const SET_COMPANY = "SET_COMPANY";
export const GET_COMPANY_BY_ID_SUCCESS = "GET_COMPANY_BY_ID_SUCCESS";
export const GET_COMPANY_BY_ID_ERROR = "GET_COMPANY_BY_ID_ERROR";

export const SET_ADMIN_COMPANY = "SET_ADMIN_COMPANY";
export const GET_ADMIN_COMPANY_BY_ID_SUCCESS =
  "GET_ADMIN_COMPANY_BY_ID_SUCCESS";
export const GET_ADMIN_COMPANY_BY_ID_ERROR = "GET_ADMIN_COMPANY_BY_ID_ERROR";

export const GET_COMPANIES_START = "GET_COMPANIES_START";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_CSV_SUCCESS = "GET_COMPANIES_CSV_SUCCESS";
export const GET_COMPANIES_ERROR = "GET_COMPANIES_ERROR";

export const CREATE_COMPANY_PAYMENT_SUCCESS = "CREATE_COMPANY_PAYMENT_SUCCESS";
export const UPDATE_COMPANY_PAYMENT_SUCCESS = "UPDATE_COMPANY_PAYMENT_SUCCESS";

export const COMPANY_PROFILE_FORM = "companyProfile";
export const COMPANY_PAYMENT_FORM = "companyPayment";

export function onSearchCompaniesStart() {
  return {
    type: SEARCH_COMPANIES_START
  };
}

export function onSearchCompaniesSuccess(data) {
  return {
    type: SEARCH_COMPANIES_SUCCESS,
    data
  };
}

export function onSearchCompaniesError() {
  return {
    type: SEARCH_COMPANIES_ERROR
  };
}

export function onUpdateCompanyStart() {
  return {
    type: UPDATE_COMPANY_START
  };
}

export function onUpdateCompanySuccess() {
  return {
    type: UPDATE_COMPANY_SUCCESS
  };
}

export function onUpdateCompanyError() {
  return {
    type: UPDATE_COMPANY_ERROR
  };
}

export function onCreateCompanyStart() {
  return {
    type: CREATE_COMPANY_START
  };
}

export function onCreateCompanySuccess() {
  return {
    type: CREATE_COMPANY_SUCCESS
  };
}

export function onCreateCompanyError() {
  return {
    type: CREATE_COMPANY_ERROR
  };
}

export function setCompany(data) {
  return {
    type: SET_COMPANY,
    data
  };
}

export function onGetCompanyByIdSuccess(data) {
  return {
    type: GET_COMPANY_BY_ID_SUCCESS,
    data
  };
}

export function onGetCompanyByIdError(error) {
  return {
    type: GET_COMPANY_BY_ID_ERROR,
    error
  };
}

export function setAdminCompany(data) {
  return {
    type: SET_ADMIN_COMPANY,
    data
  };
}

export function onGetAdminCompanyByIdSuccess(data) {
  return {
    type: GET_ADMIN_COMPANY_BY_ID_SUCCESS,
    data
  };
}

export function onGetAdminCompanyByIdError(error) {
  return {
    type: GET_ADMIN_COMPANY_BY_ID_ERROR,
    error
  };
}

export function onGetCompaniesStart() {
  return {
    type: GET_COMPANIES_START
  };
}

export function onGetCompaniesSuccess(companies) {
  return {
    type: GET_COMPANIES_SUCCESS,
    companies
  };
}

export function onGetCompaniesCsvSuccess(companies) {
  return {
    type: GET_COMPANIES_CSV_SUCCESS,
    companies
  };
}

export function onGetCompaniesError() {
  return {
    type: GET_COMPANIES_ERROR
  };
}

export function onCreateCompanyPaymentSuccess(data) {
  return {
    type: CREATE_COMPANY_PAYMENT_SUCCESS,
    data
  };
}

export function onUpdateCompanyPaymentSuccess(data) {
  return {
    type: UPDATE_COMPANY_PAYMENT_SUCCESS,
    data
  };
}

export function fetchCompanies() {
  return dispatch => {
    dispatch(onSearchCompaniesStart());
    dispatch(setPagination({}));

    api
      .fetchCompanies()
      .then(response => {
        const { data } = response.data;

        dispatch(setPagination(data));
        dispatch(onSearchCompaniesSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onSearchCompaniesError());
      });
  };
}

export function searchCompanies(query) {
  return dispatch => {
    dispatch(onSearchCompaniesStart());
    api
      .searchCompanies(query)
      .then(res => {
        dispatch(onSearchCompaniesSuccess(res.data));
      })
      .catch(() => {
        dispatch(onSearchCompaniesError());
      });
  };
}

export function updateCompany(company) {
  return dispatch => {
    dispatch(onUpdateCompanyStart());

    api
      .updateCompany(company)
      .then(() => {
        dispatch(onUpdateCompanySuccess());
        dispatch(push("/company/home"));
      })
      .catch(error => {
        dispatch(stopSubmit(COMPANY_PROFILE_FORM, error.response.data.errors));
        dispatch(onUpdateCompanyError());
      });
  };
}

export function updateCompanyById(company) {
  return dispatch => {
    dispatch(setLoading(true));
    dispatch(onUpdateCompanyStart());

    api
      .updateCompanyById(company)
      .then(() => {
        dispatch(onUpdateCompanySuccess());
        dispatch(setAdminCompany({}));
        dispatch(getAdminCompanyById(company.companyId));
      })
      .catch(error => {
        dispatch(stopSubmit(COMPANY_PROFILE_FORM, error.response.data.errors));
        dispatch(onUpdateCompanyError());
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function createCompany(company) {
  return dispatch => {
    dispatch(onCreateCompanyStart());

    api
      .createCompany(company)
      .then(() => {
        dispatch(onCreateCompanySuccess());
      })
      .catch(error => {
        dispatch(stopSubmit(COMPANY_PROFILE_FORM, error.response.data.errors));
        dispatch(onCreateCompanyError());
      });
  };
}

export function getCompanyById(companyId) {
  return dispatch => {
    dispatch(setCompany({}));

    api
      .getCompanyById(companyId)
      .then(res => {
        dispatch(onGetCompanyByIdSuccess(res.data.data));
      })
      .catch(error => {
        dispatch(onGetCompanyByIdError(error.response));
      });
  };
}

export function getAdminCompanyById(companyId, load = true) {
  return dispatch => {
    if (load) {
      dispatch(setLoading(true));
    }
    dispatch(setAdminCompany({}));

    api
      .getAdminCompanyById(companyId)
      .then(res => {
        dispatch(onGetAdminCompanyByIdSuccess(res.data.data));
      })
      .catch(error => {
        dispatch(onGetAdminCompanyByIdError(error.response));
      })
      .finally(() => {
        if (load) {
          dispatch(setLoading(false));
        }
      });
  };
}

export function getAdminCompanies(filters = "") {
  return dispatch => {
    dispatch(onGetCompaniesStart());
    dispatch(setPagination({}));

    api
      .getAdminCompanies(filters)
      .then(response => {
        const { data } = response.data;

        dispatch(setPagination(data));
        dispatch(onGetCompaniesSuccess(data));
      })
      .catch(() => {
        dispatch(onGetCompaniesError());
      });
  };
}

export function getAdminCompaniesCSVData(filters = "") {
  return dispatch => {
    // dispatch(onGetCompaniesStart());

    api
      .getAdminCompaniesForCSV(filters)
      .then(response => {
        const { data } = response.data;
        dispatch(onGetCompaniesCsvSuccess(data));
      })
      .catch(() => {
        dispatch(onGetCompaniesError());
      });
  };
}

export function createCompanyPayment(payload, loading = true) {
  return dispatch => {
    if (loading) {
      dispatch(setLoading(true));
    }

    api
      .createCompanyPayment(payload)
      .then(response => {
        const data = response.data.data;
        dispatch(onCreateCompanyPaymentSuccess(data));
      })
      .catch(error => {
        dispatch(stopSubmit(COMPANY_PAYMENT_FORM, error.response.data.errors));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function updateCompanyPayment(id, payload, loading = true) {
  return dispatch => {
    if (loading) {
      dispatch(setLoading(true));
    }

    api
      .updateCompanyPayment(id, payload)
      .then(response => {
        const data = response.data.data;
        dispatch(onUpdateCompanyPaymentSuccess(data));
      })
      .catch(error => {
        dispatch(stopSubmit(COMPANY_PAYMENT_FORM, error.response.data.errors));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/company.actions.js